// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__LdTC_","projectRadarImageAndTitle":"styles_projectRadarImageAndTitle__7ToBr","text":"styles_text__F2LME","boldText":"styles_boldText__kMb6K","buttonsWrapper":"styles_buttonsWrapper__Txo5R","buttons":"styles_buttons__zXJIq"};
module.exports.__checksum = "b0a47f0ba84f"
